import { useEffect, useState } from 'react'
import { CollapseDetails } from '../CollapseDetails'
import PropTypes from 'prop-types'
import useWindowSize from '../../hooks/useWindowSize'

function CollapsibleContent({ id, name, children }) {
  // isOpen can't be derived directly from windowSize during render:
  // useWindowSize() already returns the real (desktop-aware) viewport
  // width on the client's first render, but undefined during SSR --
  // deriving isOpen straight from it would make a desktop client's
  // hydration render disagree with the server-rendered markup for any
  // non-portfolio section. Seed isOpen with the SSR-safe value and let
  // this effect correct it once mounted, same as before.
  const [isOpen, setIsOpen] = useState(id === 'portfolio')
  const windowSize = useWindowSize()

  useEffect(() => {
    const isDesktop = windowSize?.width >= 900
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsOpen(isDesktop || id === 'portfolio')
  }, [windowSize?.width, id])

  return (
    <CollapseDetails id={id} title={name} isOpen={isOpen}>
      {children}
    </CollapseDetails>
  )
}

CollapsibleContent.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default CollapsibleContent
